module.exports = __webpack_public_path__ + "img/filters.0666363.svg";